import { create } from 'zustand'
import { devtools, persist } from 'zustand/middleware'
import { createStorage } from './storage'

interface SettingsState {
  privacyPolicyAccepted: boolean
  setPrivacyPolicyAccepted: (privacyPolicyAccepted: boolean) => void
}

const initialSettings = {
  privacyPolicyAccepted: false
}

// noinspection JSUnusedGlobalSymbols
export const useSettingsStore = create<SettingsState>()(
  devtools(
    persist(
      (set) => ({
        privacyPolicyAccepted: initialSettings.privacyPolicyAccepted,
        setPrivacyPolicyAccepted: (privacyPolicyAccepted: boolean) =>
          set({ privacyPolicyAccepted })
      }),
      {
        name: 'settings-storage',
        storage: createStorage(),
        version: 0
      }
    )
  )
)
